import React from 'react';
import './CamerasGrid.css';
import WebRTCPlayer from './WebRTCPlayer';
import HlsLlPlayer from './HlsLlPlayer';

/*
const CamerasGrid = ({ cameras }) => {
  return (
    <div className="video-grid">
      {cameras.map(camera => (
        <div key={camera.id} className="video-player">
          <WebRTCPlayer 
            name={camera.name}
            uuid={camera.webrtc_uuid}
            channel={camera.webrtc_channel}
            barrier={camera.barrier}
          />
        </div>
      ))}
    </div>
  );
};
*/

const CamerasGrid = ({ cameras }) => {
  return (
    <div className="video-grid">
      {cameras.map(camera => (
        <div key={camera.id} className="video-player">
          <HlsLlPlayer 
            uuid={camera.webrtc_uuid}
            barrier={camera.barrier}
            ></HlsLlPlayer>
        </div>
      ))}
    </div>
  );
};

export default CamerasGrid;